import emptyUserObject from '../../resources/emptyUserObject.json';


const loadFromLocalStorage = () => {
  const localUserObject = JSON.parse(localStorage.getItem('userObject'))
  let output = localUserObject ? localUserObject : emptyUserObject;
  return output
}

export default loadFromLocalStorage